module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c"
  }, [_c('div', {
    staticClass: "fake-header",
    staticStyle: {
      "height": "80px",
      "width": "100%",
      "background": "#218BEF"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "showye"
  }, [_c('div', {
    staticClass: "maincontent"
  }, [_c('div', {
    staticClass: "content-title"
  }, [_c('div', {
    staticClass: "content-top"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/explain/nemb.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("当前位置：首页 > 事项详情 > 政策解读")])]), _vm._v(" "), _c('div', {
    staticClass: "content-middle"
  }, [_c('p', [_vm._v("税务云课堂 便利纳税人")])]), _vm._v(" "), _c('div', {
    staticClass: "content-bottom"
  }, [_c('div', {
    staticClass: "content-bottom-l"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../static/img/explain//fabushijian.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v("发布时间: 2022-11-25 18:58")])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../static/img/explain//laiyuan.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v("来源: 本网")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-bottom-r"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/explain//dayin.png"),
      "alt": ""
    }
  }), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("【打印】")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/explain//dazhongxiao.png"),
      "alt": ""
    }
  }), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("【小 中 大】")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/explain//fenxiangdao.png"),
      "alt": ""
    }
  }), _vm._v(" 分享到:\n                  "), _c('img', {
    attrs: {
      "src": require("../../static/img/explain//qq.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../static/img/explain//qqkongjian.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../static/img/explain//weibo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../static/img/explain//weixin.png"),
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-content"
  }, [_c('div', {
    staticClass: "title-bg"
  }, [_c('img', {
    staticClass: "biaoti-img",
    attrs: {
      "src": require("../../static/img/explain/biaiti39.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("标题1")])]), _vm._v(" "), _c('div', {
    staticClass: "content-text"
  }, [_c('p', {
    staticClass: "content-text-title1"
  }, [_vm._v("海珠区税务部门为纳税人缴费人开设一系列线上税费政策宣传辅导活动")]), _vm._v(" "), _c('p', {
    staticClass: "content-text-title2"
  }, [_vm._v("近年来，广州市海珠区税务部门聚焦“非接触式”办税缴费，为纳税人缴费人开设一系列线上税费政策宣传辅导活动。每周一两期课堂，每次针对一个企业最为关注的话题，进行深度的解读和分析。“每一个话题都是我们‘潜伏’的成果。”郑典鹏笑着说。为了帮助企业纳税人更快更好找到笞疑解惑的税务人员，他们搭建了税企沟通平台，由对口的税务人员及时解答问题。")]), _vm._v(" "), _c('p', [_vm._v("“你看，我的表情是不是还有点僵硬，我可是强装镇定。”开播前，广州市海珠区税务干部郑典鹏坐在海珠区税收融媒体工作室的直播间里，脸被巨大的环形灯照着，显得柔和而自然，让人更不相信他打趣说的“紧张”。")]), _vm._v(" "), _c('p', [_vm._v("直播开始了。在屏幕前，郑典鹏侃侃而谈，从纳税人缴费人最近夫注的税务热点入手，引出当天“海珠税务云课堂”的主题。他已经主持了无数次云课堂，对于“抛头露面”，从一开始的“赶鸭子上架”，到“习以为常”。")]), _vm._v(" "), _c('div', {
    staticClass: "text-img"
  }, [_c('div', {
    staticClass: "tp"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/explain/WechatIMG123.jpeg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("国家税务总局广州市税务局纳税服务运营中心(海珠)云税厅")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-content"
  }, [_c('div', {
    staticClass: "title-bg"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/explain/biaiti39.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("标题2")])]), _vm._v(" "), _c('div', {
    staticClass: "content-text"
  }, [_c('p', [_vm._v("近年来，广州市海珠区税务部门聚焦“非接触式”办税缴费，为纳税人缴费人开设一系列线上税费政策宣传辅导活动。每周一两期课堂，每次针对一个企业最为关注的话题，进行深度的解读和分析。“每一个话题都是我们‘潜伏’的成果。”郑典鹏笑着说。为了帮助企业纳税人更快更好找到笞疑解惑的税务人员，他们搭建了税企沟通平台，由对口的税务人员及时解答问题。")]), _vm._v(" "), _c('div', {
    staticClass: "text-img"
  }, [_c('div', {
    staticClass: "tp"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/explain/WechatIMG124.jpeg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("郑典鹏(左)和同事在讨论税务问题")])]), _vm._v(" "), _c('p', [_vm._v("相对简单的问题，驻守的税务人员及时给出答复，而郑典鹏的主要工作是关注和收集共性问题，与相关业务科室沟通后统一答复，更复杂的问题，则组织“云课堂”进行深入解答:“不同的业务人员是我们的‘智囊团’，支持课堂更及时、更专业、更实用。”")]), _vm._v(" "), _c('p', [_vm._v("这是优化经常性涉企服务的举措，可以帮助纳税人及时找到税务人员，及时实现咨询，让纳税人少跑马路，节约纳税人往返税务部门的成本，极大地便利了纳税人。")]), _vm._v(" "), _c('p', [_vm._v("在做这个岗位前，郑典鹏在基层税源管理所做管理员，对于一线工作比较熟悉，也长时间跟纳税人打交道，了解纳税人所想所需。“一开始我很担心自己的普通话不标准，说话又比较快，不能发挥好沟通作用。”郑典鹏笑着说，经过慢慢训练，自己有了很大的提升，“我们都一样，都要从原来的单一方向转变为全方位服务。”")]), _vm._v(" "), _c('p', [_vm._v("“其实现在也是一种沟通。”郑典鹏说，优化税收营商环境和提升纳税人办税缴费体验，需要多方联动协调，更加需要跟上级部门、税源管理所和纳税人沟通，“我们所做的，就是让普通纳税人缴费人在面对复杂的税费问题时，理解起来更简单、更便捷、更有效。”")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-content"
  }, [_c('div', {
    staticClass: "title-bg"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/explain/biaiti39.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("好措施")])]), _vm._v(" "), _c('div', {
    staticClass: "content-text"
  }, [_c('p', [_vm._v("2023年是全国税务系统“便民办税春风行动”的第10年，围绕国家税务总局“办好惠民事·服务现代化”行动主题，以广东省税务局“四通”为着力点,广州市税务局以“四新”为抓手，推出“穗税春风惠民12条”便利化措施，助力开创广州高质量发展新格局。")]), _vm._v(" "), _c('p', [_vm._v("便利化措施中包括在“云税厅”中推广应用“云会客”“云调解”功能;以“非接触、云见面可视化”的方式进行业务的咨询和办理，以及远程解决税费争议问题;拓展“边办边问”业务范围，分步实现同项业务，咨询办理双向畅行的“咨办―体”服务等。")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8acfbf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Explain.vue
// module id = 1184
// module chunks = 0